import React, {Suspense} from "react";
import Routes from "./routes/index";
import {ApolloProvider} from '@apollo/client';
import {Spin} from "antd";
import {Provider} from "react-redux";
import store from "./redux/store";
import {client} from "./graphql/Client"
import _ from 'lodash';
import KeycloakProvider from "./provider/keycloak";

const Root = () => {

    const spin = <div style={{textAlign: "center"}}>
        <Spin/>
    </div>

    return <Suspense fallback={spin}>
        <div className={'full-height'}>
            <Provider store={store}>
                <KeycloakProvider>
                    <ApolloProvider client={client}>
                        <Routes />
                    </ApolloProvider>
                </KeycloakProvider>
            </Provider>
            <div style={{bottom: 0, textAlign: "center", padding: 10}}>
                © {new Date().getFullYear()} Pfeiffer Vacuum GmbH | Version: {_.get(window, '__VERSION__')}
            </div>
        </div>
    </Suspense>
};

export default Root;
